import FragmentApp from 'renderer/FragmentApp';
import { hydrateClient } from 'client/hydrateClient';
import { islandController } from 'client/islandController';
import { WINDOW_DATA_PROPERTY_NAME } from 'constants/render';
import { logHydrationError } from 'client/logHydrationError';

export const renderFragmentClient = async (contentRoot: HTMLElement) => {
  window.dataLayer = window.dataLayer || [];

  if (!contentRoot) {
    logHydrationError(new Error(`Content Renderer: Missing content root`), 'fragment');
    return null;
  }

  const namespace = contentRoot.getAttribute('data-cr-content');

  if (!namespace) {
    logHydrationError(
      new Error('Content Renderer: Missing "data-cr-content" attribute on fragment container'),
      'fragment',
    );
    return null;
  }

  const { content, config } = window[WINDOW_DATA_PROPERTY_NAME] || {};
  const contentData = content?.[namespace];

  if (!contentData) {
    logHydrationError(
      new Error(`Content Renderer: Missing window data payload for fragment "${namespace}"`),
      'fragment',
    );
    return null;
  }

  const { componentData = [], preloadedData } = contentData;

  const root = hydrateClient({
    loggerName: 'fragment',
    appElement: (
      <FragmentApp
        componentLibraryConfig={{
          ...(config || {}),
          cfDomain: config?.cfDomain ?? '',
        }}
        componentData={componentData}
        contentPath={namespace}
        preloadedData={preloadedData ?? {}}
      />
    ),
    contentRoot,
    namespace,
  });

  return root;
};

islandController.initialise(renderFragmentClient);
